import { useMemo } from "react"
import { get, keyBy, orderBy } from "lodash"
import { useVenue } from "providers/venue"
import { getFeatureDetail } from "utils/feature"
import { useTranslation } from "providers/i18n"

const EM_KIDS_AND_FAMILY_REF = "local-category-emdistrict-0-kids-and-family"
const EM_KIDS_AND_FAMILY_CATEGORY = "Kid’s and Family"

const isKidsAndFamilyCategory = (category) =>
  category?.properties?.reference === EM_KIDS_AND_FAMILY_REF

//TODO:: add logic to this hook later
export const useKidsAndFamily = () => {
  const { occupants, events, promotions, sections } = useVenue()
  const { t } = useTranslation()

  const kidsAndFamilyOccupants = useMemo(
    () =>
      occupants.filter((occupant) => {
        const parentCategories = get(
          occupant,
          "properties.local_parent_categories"
        )
        return parentCategories.find(isKidsAndFamilyCategory)
      }),
    [occupants]
  )

  const kidsAndFamilySections = useMemo(
    () =>
      sections.filter((section) => {
        const isHideFromShopList = section?.properties?.hide_from_shop_list
        const sectionDetail = getFeatureDetail(section)
        const sectionCategory = t(sectionDetail?.category)

        return (
          !isHideFromShopList && sectionCategory === EM_KIDS_AND_FAMILY_CATEGORY
        )
      }),
    [sections, t]
  )

  const kidsAndFamilyOccupantsObj = useMemo(
    () => keyBy(kidsAndFamilyOccupants, "id"),
    [kidsAndFamilyOccupants]
  )

  const kidsAndFamilyPromotions = useMemo(
    () =>
      promotions.filter((promotion) => {
        const promotionLocationId = promotion?.properties?.feature?.id
        return !!(
          promotionLocationId && kidsAndFamilyOccupantsObj[promotionLocationId]
        )
      }),
    [promotions, kidsAndFamilyOccupantsObj]
  )

  const kidsAndFamilyEvents = useMemo(
    () =>
      events.filter((event) => {
        const eventLocationId = event?.properties?.feature?.id
        return !!(eventLocationId && kidsAndFamilyOccupantsObj[eventLocationId])
      }),
    [events, kidsAndFamilyOccupantsObj]
  )
  const sortedKidsAndFamilyEventsAndPromotions = useMemo(() => {
    return orderBy(
      [...kidsAndFamilyPromotions, ...kidsAndFamilyEvents],
      [
        "properties.is_featured",
        "properties.start_date",
        "properties.end_date",
      ],
      ["desc", "asc", "asc"]
    )
  }, [kidsAndFamilyEvents, kidsAndFamilyPromotions])

  return {
    occupants: kidsAndFamilyOccupants,
    sections: kidsAndFamilySections,
    promotions: kidsAndFamilyPromotions,
    events: kidsAndFamilyEvents,
    eventsAndPromotions: sortedKidsAndFamilyEventsAndPromotions,
  }
}
